__turbopack_context__.v({
  "content": "MemberDetailsLoginStrip-module-scss-module__HneNSW__content",
  "descName": "MemberDetailsLoginStrip-module-scss-module__HneNSW__descName",
  "loginButton": "MemberDetailsLoginStrip-module-scss-module__HneNSW__loginButton",
  "loginIcon": "MemberDetailsLoginStrip-module-scss-module__HneNSW__loginIcon",
  "root": "MemberDetailsLoginStrip-module-scss-module__HneNSW__root",
  "secondary": "MemberDetailsLoginStrip-module-scss-module__HneNSW__secondary",
});
